import { useDarkModeGatingCriteria } from "./useDarkModeGatingCriteria";
import { useDarkModeSettings } from "./useDarkModeSettings";

export default function useDarkMode() {
  const { darkModeEnabled: enabledInPreferences } = useDarkModeSettings();
  const { criteriaMet, isLoading } = useDarkModeGatingCriteria();

  return {
    darkModeEnabled: enabledInPreferences && (criteriaMet || isLoading)
  };
}
